import Head from 'next/head';
import React, { ReactElement } from 'react';
import Section from 'components/ToolForgotPassword/Section';

const ForgotPassword = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Recruiter Password Reset | Huzzle</title>
        <meta
          name="description"
          content="Forgot your password? Reset it here for your Recruiter account."
        />
      </Head>
      <Section isRecruiter />
    </>
  );
};

export default ForgotPassword;
